import { FC } from 'react';

import { Box, css, styled } from '@mui/material';

import { ProcessedDepressionData } from 'models/DepressionScreening';

import { Text } from 'components/UIkit/atoms/Text/Text';

type DepressionScreeningHeaderProps = {
  depressionData: ProcessedDepressionData;
  isExpanded?: boolean;
};

export const DepressionScreeningHeader: FC<DepressionScreeningHeaderProps> = ({
  isExpanded,
  depressionData: { phqType, totalScore, hasSuicidalIdeation }
}) => {
  return (
    <StyledHeader isExpanded={isExpanded}>
      <Text variant="body1">{phqType} Score:</Text>
      <Text variant="body2">
        {totalScore} Point{totalScore === 1 ? '' : 's'}
      </Text>
      {hasSuicidalIdeation && (
        <StyledSuicidalBadge>
          <Text variant="body2">Suicidal Ideation</Text>
        </StyledSuicidalBadge>
      )}
    </StyledHeader>
  );
};

const StyledHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isExpanded'
})<{ isExpanded?: boolean }>(
  ({ theme, isExpanded }) => css`
    margin-top: ${theme.spacing(isExpanded ? 20 : 12)};
    margin-bottom: ${theme.spacing(12)};
    display: flex;
    align-items: center;
    gap: ${theme.spacing(4)};
  `
);

const StyledSuicidalBadge = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.palette.tag.highRisk};
    color: ${theme.palette.text.primary};
    padding: ${theme.spacing(0, 4)};
    border-radius: 3px; // TODO: refactor Item.Chip and decide what todo with design system
  `
);
